import { drainAnswerSaves } from '@/store/utilities/AnswerSaveQueue.js';

export function findQuizAttemptModule(store, attemptId) {
    if (!Number(attemptId)) return null;
    return (
        Object.entries(store.state.QuizAttempt ?? {}).find(
            ([, module]) => Number(module?.quiz_attempt?.id) === Number(attemptId)
        )?.[0] ?? null
    );
}

// Settle writes before a server-driven transition can replace the question UI.
// An unsuccessful save keeps the attempt and its navigation protection intact.
export async function synchronizeQuizStatus(store, event, isCurrent = () => true) {
    const moduleId = findQuizAttemptModule(store, event.quiz_attempt_id || event.user?.quiz_active_id);
    if (moduleId === null) return true;
    const state = store.state.QuizAttempt[moduleId];
    const saved = await drainAnswerSaves(state);
    if (!isCurrent() || store.state.QuizAttempt?.[moduleId] !== state) return false;
    const failed = (state.current_question ?? []).some(item => item.question?.save_failed);
    if (!saved || failed) return false;

    const namespace = `QuizAttempt/${moduleId}`;
    const status = event.status ?? '';
    // The start prompt owns hydration, once the student proceeds. Marking the
    // attempt started here would hide failed hydration from the fallback poll.
    if (status === 'attempt-started') return true;

    if (status.includes('review') || !status) {
        const applied = await store.dispatch(`${namespace}/endAndApplyStatus`, { status: status || null, isCurrent });
        if (applied === false && isCurrent()) throw new Error('Unable to load quiz review. Please try again.');
        return true;
    }

    store.commit(`${namespace}/EDIT`, { target: state.quiz_attempt, field: 'status', value: status });
    if (status === 'in-waiting-room-post') {
        store.commit(`${namespace}/SET`, { target: 'quiz_ended', value: true });
        store.commit(`${namespace}/SET`, { target: 'time_remaining_local', value: 0 });
        store.commit(`${namespace}/SET`, { target: 'time_remaining_server', value: 0 });
    }
    await store.dispatch(`${namespace}/closeModal`);
    return true;
}
